<template>
	<div class="tree-group">
		<div class="li-div">
			<div class="  row justify-content-end  tree-group-item ">
				<div class="col-auto node-buttons" v-if="settings.editable">

					<button class="icon delete  d-sm-inline-block" v-if="typeof settings?.onNodeDeleteClicked === 'function' && !localData?.hasChild" :disabled="!settings.deletePolicyClaimsState" @click="settings.onNodeDeleteClicked(localData)" :title="$t('delete') + ' ' + '(Ctrl + Delete)'">
						<icon :icon="['fas', 'trash']" />
					</button>
					<button class="icon add  d-sm-inline-block" v-if="typeof settings?.onNodeAddClicked === 'function'" :disabled="!settings.addPolicyClaimsState" @click="settings.onNodeAddClicked(localData)" :title="$t('insert') + ' ' + '(Ctrl + Insert)'">
						<icon :icon="['fas', 'plus-circle']" />
					</button>
					<button class="icon edit  d-sm-inline-block" v-if="typeof settings?.onNodeEditClicked === 'function'" :disabled="!settings.editPolicyClaimsState" @click="settings.onNodeEditClicked(localData)" :title="$t('edit') + ' ' + '(Ctrl + Space)'">
						<icon :icon="['fas', 'edit']" />
					</button>
					<div class="d-inline" v-for="b in buttonsWithPermission" :key="b.id">
						<button v-if="(!b.treeCondition) || (b.treeCondition && b.treeCondition(localData))" :class="[' d-sm-inline-block icon', b.theme]" :disabled="typeof b.disabled === 'function' ? b.disabled(localData) : b.disabled" @click="b.handler(localData)" :title="b.title">
							<icon :icon="typeof b.icon === 'function' ? b.icon(localData) : b.icon" />
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'

	export default {
		name: "ag-tree-buttons",
		props: {
			options: Object,
			data: Object,
		},
		created() {
			_.merge(this.settings, this.options)
			if (this.params?.options)
				_.merge(this.settings, this.params.options)
			if (this.params?.data)
				_.merge(this.localData, this.params.data)
		},
		data() {
			return {
				settings: {
					editPolicyClaimsState: true,
					addPolicyClaimsState: true,
					deletePolicyClaimsState: true,
				},
				localData: {},
			}
		},
		computed: {
			buttonsWithPermission() {
				if (Array.isArray(this.settings.buttons)) {
					let filtered = this.settings.buttons.filter(x => this.$nikan.checkPermission(x.policyClaims))
					filtered.map(x => x.id = this.idGenerator(5))
					return filtered
				}
				else return []
			},
		}
	}
</script>

<style scoped></style>